var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-item-content",style:(`${_vm.imgWidth}`)},[(_vm.datamodel.value && _vm.datamodel.value.filelocation)?_c('ve-video',{staticClass:"ve-video",attrs:{"source":_vm.source,"options":_vm.options},on:{"error":_vm.handleError,"endEvent":_vm.showHeadImg}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }